/* eslint-disable no-undef */
// jQuery.ajax is not built with async/await in mind and I do not like the interface
// fetch also has the tendendcy to suck, use a proper http client if more control is needed

import AbortController from 'abort-controller';

function makeRestRequest() {
  let controller;
  let signal;

  return {
    abort() {
      if (controller && controller.abort) {
        controller.abort();
      }
    },

    async request(target, options = {}) {
      controller = new AbortController();
      signal = controller.signal;

      try {
        const res = await fetch(window.enervent.restUrl + target, {
          method: 'GET',
          signal,
          credentials: 'same-origin',
          ...options,
        });
        const { headers, status, statusText, url } = res;
        const data = await res.json();

        controller = null;

        return {
          headers,
          status,
          statusText,
          url,
          data,
        };
      } catch (e) {
        controller = null;

        if (e.name !== 'AbortError') {
          throw e; // Handle on component level
        }
        return '';
      }
    },
  };
}

export default () => makeRestRequest();

// import makeRestRequest from '../util/restReq'
// const { abort, request } = makeRestRequest()
